module.exports = "<div class=users> <md-card> <rkc-table table-definition=c.tableDefinition table-content=c.allUsers></rkc-table> </md-card> <md-button class=\"md-fab md-accent md-fab-bottom-right\" ng-click=c.handleUser() ng-show=\"c.allUsers.length>0\" layout=row> <md-tooltip>Opprett bruker</md-tooltip> <md-icon>add</md-icon> </md-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/users/users.html
 ** module id = 532
 ** module chunks = 0
 **/